import * as React from "react";
import { connect } from "react-redux";
import { match as Match } from "react-router";

import {
  GlobalPrivateState,
  formatNumber,
  QueryParameterState,
  getCountryNameByCode,
} from "src/api";

import "./../UserList/UserList.scss";
import "./Pricing.scss";
import {
  UserModel,
  accessoryPartDetails,
  isoDetails,
  getPartDetail,
  isoDetailsArray,
  CurrencyCodes,
  getMarketByCountryCode,
  getValueFromPricings,
  getNestedPricingProp,
} from "franke-trough-dependencies";
import { filterUsersBySword } from "../utils";
import { Button, Tooltip } from "reactstrap";
import {
  requestAPIActions,
  RequestApiHttpPayload,
} from "loopback-react-request";
import { PricingDispatcher } from "src/app/Container/Dispatcher/PricingDispatcher";
import PricingSwitchView from "./PricingSwitchView";
import { getParamByISO } from "iso-country-currency";
import PeriodSelectionDropdown from "../../Configuration/Checkout/Parts/PeriodSelectionDropdown";
import { PricingsDispatcher } from "src/app/Container/Dispatcher/PricingsDispatcher";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import ToastPopup, {
  ToastType,
} from "src/app/Components/ToastPopup/ToastPopup";

export interface PricingsAccessoriesProps {
  match: Match<{ pricingId: string }>;
  pricing: GlobalPrivateState["pricing"];
  pricings: GlobalPrivateState["pricings"];
  params: QueryParameterState["params"];
  history: any;
  dispatch: any;
}

const accessoryArticleToPartKey = Object.entries(accessoryPartDetails).reduce(
  (memo, [key, value]) => {
    if (value && value.article) {
      memo[value.article] = key;
    }
    return memo;
  },
  {} as Record<string, string>
);

type ParsedAccessoryRow = {
  groupKey: string;
  partKey: string;
  value: string;
  missingPrice: boolean;
};

type PricingImportFeedback = {
  updatedEntries: number;
  errors: string[];
  warnings: string[];
};

type ImportToast = {
  type: ToastType;
  header: string;
  body: React.ReactNode;
};

export class PricingsAccessoriesPartial extends React.Component<
  PricingsAccessoriesProps,
  any
> {
  constructor(props: PricingsAccessoriesProps) {
    super(props);

    const state: any = {
      pricing: {
        id: this.pricingId,
        dateFrom: null,
        dateUntil: new Date(
          new Date().setFullYear(new Date().getFullYear() + 100)
        ),
        items: [],
      },
      hasChanged: false,
      importFeedback: undefined,
      importToast: undefined,
    };

    if (
      this.props.pricing &&
      this.props.pricing.result &&
      this.props.pricing.result.id === this.pricingId
    ) {
      state.pricing = JSON.parse(JSON.stringify(this.props.pricing.result));
    } else if (this.props.pricings && this.props.pricings.result) {
      state.pricing = JSON.parse(
        JSON.stringify(
          this.props.pricings.result.find((p) => p.id === this.pricingId)
        )
      );
    }

    state.baselineValues = this.buildBaselineMap(state.pricing.items || []);
    state.placeholderKeys = {};

    this.state = state;
  }

  componentDidUpdate(prevProps: PricingsAccessoriesProps) {
    const prevParams = prevProps.params;
    const params = this.props.params;
    const prevPricing = prevProps.pricing.result;
    const pricing = this.props.pricing.result;
    const pricings = this.props.pricings.result;
    const pricingChanged = prevPricing !== pricing;

    // Finished updating/saving
    const pricingUpdated =
      this.state.pricing.dateFrom &&
      prevProps.pricing.updating &&
      !this.props.pricing.updating;
    const pricingSwitched =
      pricing &&
      pricing.id &&
      (prevPricing && prevPricing.id) &&
      prevPricing.id !== pricing.id;
    if (pricingUpdated && !pricingSwitched) {
      this.setState({
        showSaved: true,
      });

      setTimeout(() => {
        this.setState({
          showSaved: false,
        });
      }, 4000);
    }

    // Pricing items...
    // const pricingsUpdated = prevProps.pricings.updating && !this.props.pricings.updating;
    // if (pricingsUpdated) {
    //   const marketPricingsList = pricings && pricings.filter(p => p.type === 'market' && !p.deleted);

    //   if (marketPricingsList) {
    //     console.log(marketPricingsList);
    //     for (const marketPricings of marketPricingsList) {
    //       for (const partKey of partKeys) {
    //         const countryCode = getValueFromPricings(marketPricings, 'country');
    //         const item = {
    //           key: partKey,
    //           value: formatNumber(0, { minimumFractionDigits: 2, maximumFractionDigits: 2}),
    //           countryCode: countryCode.split('-')[0]
    //         }
    //         initialItems.push(item);
    //       }
    //     }
    //   }
    // }

    const noItems =
      !this.state.pricing.items || this.state.pricing.items.length === 0;
    const prevPricingId =
      prevProps.match &&
      prevProps.match.params &&
      prevProps.match.params.pricingId;
    const pricingIdChanged = prevPricingId !== this.pricingId;

    if (pricing && pricings && (pricingChanged || pricingIdChanged || noItems)) {
      const partKeys = Object.keys(accessoryPartDetails);
      const updatedPricing = JSON.parse(JSON.stringify(pricing));
      const mergedPricingItems = [];
      const marketPricings = pricings.filter(
        (p) => p.type === "market" && !p.deleted
      );
      const groupKeys = getNestedPricingProp(marketPricings, "price_list");

      for (const partKey of partKeys) {
        for (let groupKey of groupKeys) {
          const existingItem = mergedPricingItems.find(
            (i) => i.key === partKey && i.groupKey === groupKey
          );
          if (existingItem) continue;

          const item: any = { key: partKey, groupKey };
          const matchingItem =
            pricing.items &&
            pricing.items.find(
              (i: any) => i.key === partKey && i.groupKey === groupKey
            );

          if (matchingItem) {
            item.value = matchingItem.value;
          } else {
            item.value = "0.00";
          }

          mergedPricingItems.push(item);
        }
      }

      updatedPricing.items = mergedPricingItems;
      console.log("mergedPricingItems", mergedPricingItems);

      this.setState({
        pricing: updatedPricing,
        baselineValues: this.buildBaselineMap(mergedPricingItems),
        placeholderKeys: {},
      });
    }

    // History usage...
    if (this.pricingId && this.pricingId !== this.state.pricing.id) {
      this.dispatchPricing(this.pricingId);
    }
  }

  public render() {
    const { pricing } = this.state;
    const { params, pricings } = this.props;

    const marketPricings =
      pricings.result &&
      pricings.result.filter((p) => p.type === "market" && !p.deleted);
    const selectedGroupKey: any = this.props.params.groupKey || "DE";
    const selectedMarketPricing =
      marketPricings &&
      marketPricings.find((pricing) => {
        const priceList = getValueFromPricings(pricing, "price_list");
        return selectedGroupKey === priceList;
      });
    const currency =
      selectedMarketPricing &&
      selectedMarketPricing.items.find((i) => i.key === "currency");
    const currencyLabel = (currency && currency.value) || "EUR";

    return (
      <div className="partial-pricings-accessories">
        {this.renderImportToast()}
        {(!this.props.pricings || !this.props.pricings.result) && (
          <PricingsDispatcher />
        )}
        <PricingDispatcher id={this.state.pricing.id} />
        <div className="partial-pricings-accessories__heading mb-4">
          <div className="partial-pricings-accessories__header">
            <h2>Prices Accessories</h2>
            <div className="partial-pricings-accessories__import mb-4">
              <div className="partial-pricings-accessories__import-control">
                <span className="partial-pricings-accessories__import-hint">
                  <h6>Import price update</h6>
                  Upload the SAP export file with the updated prices here.
                </span>
                <label
                  htmlFor="accessory-pricing-import"
                  className="btn btn-tertiary mb-0"
                >
                  Upload price file
                </label>
                <input
                  id="accessory-pricing-import"
                  className="partial-pricings-accessories__import-input"
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={this.handleImportFile}
                  disabled={this.props.pricing.updating}
                />
              </div>
            </div>
          </div>
          <div className="partial-pricings-accessories__selector">
            <PeriodSelectionDropdown
              pricings={this.props.pricings}
              selectedPeriod={this.state.pricing.id}
              type="accessories"
              isDisabled={this.props.pricing.updating}
              onChange={(event: any, type: string) => {
                const newId = event.target.value;
                this.props.history.replace(`/pricings-accessories/${newId}`);
                this.dispatchPricing(newId);
              }}
              label="Time Period"
            />
          </div>
        </div>
        <div className="container">
          <div className="row view-switcher">
            <div className="col-12 p-0">
              <PricingSwitchView />
            </div>
          </div>
        </div>
        <ol className="pricings-list">
          <li className="pricings-list__header">
            <span className="pricings-list__cell pricings-list__shortcode">
              Shortcode
            </span>
            <span className="pricings-list__cell pricings-list__materialno">
              Material No.
            </span>
            <span className="pricings-list__cell pricings-list__name">
              Designation DE
            </span>
            <span className="pricings-list__cell pricings-list__price">
              Price in {(currency && currency.value) || "EUR"}
            </span>
          </li>
          {pricing &&
            pricing.items &&
            pricing.items.map((item: any, index: number) => {
              if (selectedGroupKey !== item.groupKey) {
                return null;
              }

              const valueKey = this.getValueKey(item);
              const hasChangedPrice = this.hasPriceChanged(item);
              const previousPrice = this.getPreviousPrice(item);
              const isPlaceholderPrice = !!this.state.placeholderKeys[valueKey];
              const trimmedValue = (item.value || "").toString().trim();
              const numericValue = parseFloat(trimmedValue);
              const isZeroPrice =
                trimmedValue !== "" &&
                !Number.isNaN(numericValue) &&
                numericValue === 0;
              const isEmptyPrice =
                !trimmedValue || isPlaceholderPrice || isZeroPrice;

              return (
                <li
                  className="pricings-list__item"
                  key={item.key + item.groupKey}
                >
                  <span className="pricings-list__cell pricings-list__shortcode">
                    {getPartDetail(item.key, "part_type", "de")}
                  </span>
                  <span className="pricings-list__cell pricings-list__materialno">
                    {getPartDetail(item.key, "article", "de")}
                  </span>
                  <span className="pricings-list__cell pricings-list__name">
                    {getPartDetail(item.key, "name", "de")}
                  </span>
                  {hasChangedPrice && previousPrice !== undefined && (
                    <div className="pricings-list__previous">
                      was {previousPrice} {currencyLabel}
                    </div>
                  )}
                  <span className="pricings-list__cell pricings-list__price">
                    <input
                      type="text"
                      value={item.value || ""}
                      onChange={(e) => this.handleChangeValue(e, index)}
                      disabled={this.props.pricing.updating}
                      className={[
                        hasChangedPrice
                          ? "pricings-list__price-input--changed"
                          : "",
                        isEmptyPrice ? "pricings-list__price-input--empty" : "",
                      ]
                        .filter(Boolean)
                        .join(" ")}
                    />
                    <div>{currencyLabel}</div>
                  </span>
                </li>
              );
            })}
        </ol>

        <div className="pricings-list__cta">
          <Button
            className="btn"
            onClick={() => this.handleSave()}
            disabled={this.props.pricing.updating || !this.state.hasChanged}
            id="pricings-list__cta-btn"
          >
            <span className="btn-name">Update prices</span>
          </Button>
          {this.state.showSaved && (
            <Tooltip
              autohide={false}
              isOpen={true}
              placement="top"
              target="pricings-list__cta-btn"
            >
              {(this.props.pricing.error &&
                this.props.pricing.error.message) || (
                <>Changes have been saved successfully</>
              )}
            </Tooltip>
          )}
        </div>
      </div>
    );
  }

  handleImportFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target;
    const file = input && input.files && input.files[0];
    if (!file) {
      this.updateImportFeedback(
        0,
        ["Please select an Excel file to import."],
        []
      );
      return;
    }

    const resetInput = () => {
      if (input) {
        input.value = "";
      }
    };

    const reader = new FileReader();
    reader.onload = (loadEvent: any) => {
      try {
        const data = loadEvent.target && loadEvent.target.result;
        if (!data) {
          this.updateImportFeedback(
            0,
            ["The uploaded file was empty or could not be read."],
            []
          );
          return;
        }

        const workbook = XLSX.read(data as ArrayBuffer, { type: "array" });
        const parsed = this.parseAccessoryRows(workbook);

        if (parsed.errors.length && parsed.rows.length === 0) {
          this.updateImportFeedback(0, parsed.errors, parsed.warnings);
          return;
        }

        this.mergeImportedPrices(parsed.rows, parsed.errors, parsed.warnings);
      } catch (error) {
        const fallback = "Unable to parse the Excel file.";
        const message =
          error && typeof error === "object" && "message" in error
            ? (error as Error).message
            : fallback;
        this.updateImportFeedback(0, [message], []);
      } finally {
        resetInput();
      }
    };

    reader.onerror = () => {
      this.updateImportFeedback(0, ["Unable to read the selected file."], []);
      resetInput();
    };

    reader.readAsArrayBuffer(file);
  };

  private parseAccessoryRows(workbook: XLSX.WorkBook) {
    const sheetData = this.findAccessorySheet(workbook);
    if (!sheetData) {
      return {
        rows: [],
        errors: [
          'Could not locate the conditions table. A header row named "ConditionRateValueText" is required.',
        ],
        warnings: [],
      };
    }

    const { rows, headerRowIndex } = sheetData;
    console.log("headerRowIndex", headerRowIndex);
    const headerRow = rows[headerRowIndex] || [];
    const materialIndex = this.getColumnIndex(headerRow, "Material");
    const priceListIndex = this.getColumnIndex(headerRow, "PriceListType");
    const rateIndex = this.getColumnIndex(headerRow, "ConditionRateValueText");

    const missingColumns: string[] = [];
    if (materialIndex === -1) {
      missingColumns.push("Material");
    }
    if (priceListIndex === -1) {
      missingColumns.push("PriceListType");
    }
    if (rateIndex === -1) {
      missingColumns.push("ConditionRateValueText");
    }

    if (missingColumns.length > 0) {
      return {
        rows: [],
        errors: [
          `Uploaded sheet is missing column(s): ${missingColumns.join(", ")}.`,
        ],
        warnings: [],
      };
    }

    const parsedRows: ParsedAccessoryRow[] = [];
    const warnings: string[] = [];

    for (
      let rowIndex = headerRowIndex + 1;
      rowIndex < rows.length;
      rowIndex++
    ) {
      const row = rows[rowIndex];
      if (!row) {
        continue;
      }

      const sheetRowNumber = rowIndex + 1;
      const materialValue = this.normalizeCellValue(row[materialIndex]);
      if (!materialValue || materialValue.toLowerCase() === "material") {
        continue;
      }

      const priceListRaw = this.normalizeCellValue(row[priceListIndex]);
      if (!priceListRaw) {
        warnings.push(`Row ${sheetRowNumber}: missing PriceListType.`);
        continue;
      }

      const normalizedPriceList = priceListRaw.toUpperCase();
      const normalizedPrice = this.normalizePriceValue(row[rateIndex]);
      const priceValue = normalizedPrice === null ? "" : normalizedPrice;
      if (normalizedPrice === null) {
        warnings.push(
          `Row ${sheetRowNumber}: invalid price for article ${materialValue}.`
        );
      }

      const partKey = accessoryArticleToPartKey[materialValue];
      if (!partKey) {
        warnings.push(
          `Row ${sheetRowNumber}: article ${materialValue} is not recognised.`
        );
        continue;
      }

      parsedRows.push({
        groupKey: normalizedPriceList,
        partKey,
        value: normalizedPrice || "0.00",
        missingPrice: normalizedPrice === null,
      });
    }

    return {
      rows: parsedRows,
      errors: [],
      warnings,
    };
  }

  private findAccessorySheet(workbook: XLSX.WorkBook) {
    for (const sheetName of workbook.SheetNames) {
      const sheet = workbook.Sheets[sheetName];
      if (!sheet) {
        continue;
      }

      const rows = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
        defval: "",
      }) as any[][];
      const headerRowIndex = rows.findIndex(
        (row) =>
          row &&
          row.some(
            (cell) =>
              typeof cell === "string" &&
              cell.trim().toLowerCase() === "conditionratevaluetext"
          )
      );

      if (headerRowIndex >= 0) {
        const headerRow = rows[headerRowIndex] || [];
        const materialIndex = this.getColumnIndex(headerRow, "Material");
        const priceListIndex = this.getColumnIndex(headerRow, "PriceListType");
        const rateIndex = this.getColumnIndex(
          headerRow,
          "ConditionRateValueText"
        );

        if (
          this.hasAccessoryDataRows(
            rows,
            headerRowIndex,
            materialIndex,
            priceListIndex,
            rateIndex
          )
        ) {
          return {
            rows,
            headerRowIndex,
            sheetName,
          };
        }
      }
    }

    return undefined;
  }

  private hasAccessoryDataRows(
    rows: any[][],
    headerRowIndex: number,
    materialIndex: number,
    priceListIndex: number,
    rateIndex: number
  ) {
    if (materialIndex === -1 || priceListIndex === -1 || rateIndex === -1) {
      return false;
    }

    for (
      let rowIndex = headerRowIndex + 1;
      rowIndex < rows.length;
      rowIndex++
    ) {
      const row = rows[rowIndex];
      if (!row) {
        continue;
      }

      const materialValue = this.normalizeCellValue(row[materialIndex]);
      const priceList = this.normalizeCellValue(row[priceListIndex]);
      const rateValue = this.normalizeCellValue(row[rateIndex]);

      if (!materialValue || !priceList || !rateValue) {
        continue;
      }

      const numericPrice = rateValue
        .replace(/\s+/g, "")
        .replace(/,/g, ".")
        .replace(/[^0-9.-]/g, "");

      if (!/\d/.test(materialValue) || numericPrice.length === 0) {
        continue;
      }

      if (!Number.isNaN(parseFloat(numericPrice))) {
        return true;
      }
    }

    return false;
  }

  private getColumnIndex(headerRow: any[], columnName: string) {
    const normalized = columnName.toLowerCase();
    return headerRow.findIndex(
      (cell) =>
        typeof cell === "string" && cell.trim().toLowerCase() === normalized
    );
  }

  private normalizeCellValue(value: any) {
    if (value === undefined || value === null) {
      return "";
    }

    if (typeof value === "string") {
      return value.trim();
    }

    return value.toString().trim();
  }

  private normalizePriceValue(cell: any) {
    const rawValue = this.normalizeCellValue(cell);
    if (!rawValue) {
      return null;
    }

    const sanitized = rawValue
      .replace(/\s+/g, "")
      .replace(/,/g, ".")
      .replace(/[^0-9.-]/g, "");

    if (!sanitized) {
      return null;
    }

    const numeric = parseFloat(sanitized);
    if (Number.isNaN(numeric)) {
      return null;
    }

    return numeric.toFixed(2);
  }

  private mergeImportedPrices(
    rows: ParsedAccessoryRow[],
    errors: string[],
    warnings: string[]
  ) {
    const existingItems = (this.state.pricing.items || []).map((item: any) => ({
      ...item,
    }));
    let updatedEntries = 0;
    const nextBaselineValues = { ...this.state.baselineValues };
    const nextPlaceholderKeys = { ...this.state.placeholderKeys };

    for (const parsedRow of rows) {
      const valueKey = this.getValueKey({
        key: parsedRow.partKey,
        groupKey: parsedRow.groupKey,
      });

      if (nextBaselineValues[valueKey] === undefined) {
        nextBaselineValues[valueKey] = parsedRow.value || "";
      }

      if (parsedRow.missingPrice) {
        nextPlaceholderKeys[valueKey] = true;
      } else if (nextPlaceholderKeys[valueKey]) {
        delete nextPlaceholderKeys[valueKey];
      }

      const index = existingItems.findIndex(
        (item: any) =>
          item.groupKey === parsedRow.groupKey && item.key === parsedRow.partKey
      );

      if (index >= 0) {
        if (existingItems[index].value !== parsedRow.value) {
          existingItems[index] = {
            ...existingItems[index],
            value: parsedRow.value,
          };
          updatedEntries++;
        }
      } else {
        existingItems.push({
          key: parsedRow.partKey,
          groupKey: parsedRow.groupKey,
          value: parsedRow.value,
        });
        updatedEntries++;
      }
    }

    this.setState({
      pricing: {
        ...this.state.pricing,
        items: existingItems,
      },
      hasChanged: updatedEntries > 0 || this.state.hasChanged,
      baselineValues: nextBaselineValues,
      placeholderKeys: nextPlaceholderKeys,
    });

    this.updateImportFeedback(updatedEntries, errors, warnings);
  }

  dispatchPricing = (pricingId: string) => {
    this.props.dispatch(
      requestAPIActions.load(
        "pricing",
        {
          url: `/Pricings/${pricingId}`,
        },
        true
      )
    );

    this.setState({
      pricing: {
        ...this.state.pricing,
        id: pricingId,
      },
    });
  };

  handleSave = () => {
    this.props.dispatch(
      requestAPIActions.load<RequestApiHttpPayload>("pricing", {
        url: "/Pricings",
        options: {
          method: "PATCH",
          data: this.state.pricing,
        },
      })
    );

    this.setState((prevState: any) => ({
      ...prevState,
      hasChanged: false,
      baselineValues: this.buildBaselineMap(prevState.pricing.items || []),
      placeholderKeys: {},
    }));
  };

  handleChangeValue = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const editedItems = [...this.state.pricing.items];
    const currentItem = { ...editedItems[index] };
    currentItem.value = event.target.value;
    currentItem.value = currentItem.value.replace(",", ".");
    currentItem.value = currentItem.value.replace(/[^0-9.]/g, "");
    editedItems[index] = currentItem;
    const valueKey = this.getValueKey(currentItem);
    const nextPlaceholderKeys = { ...this.state.placeholderKeys };
    if (nextPlaceholderKeys[valueKey]) {
      delete nextPlaceholderKeys[valueKey];
    }

    this.setState({
      pricing: {
        ...this.state.pricing,
        items: editedItems,
      },
      hasChanged: true,
      placeholderKeys: nextPlaceholderKeys,
    });
  };

  private renderImportToast() {
    const { importToast } = this.state;

    if (!importToast) {
      return null;
    }

    return (
        <ToastPopup
          type={importToast.type}
          header={importToast.header}
          body={importToast.body}
          onClose={this.hideImportToast}
          duration={8000}
        />
    );
  }

  private hideImportToast = () => {
    this.setState({ importToast: undefined });
  };

  private updateImportFeedback(
    updatedEntries: number,
    errors: string[],
    warnings: string[]
  ) {
    const normalizedErrors = errors || [];
    const normalizedWarnings = warnings || [];
    const importFeedback: PricingImportFeedback = {
      updatedEntries,
      errors: normalizedErrors,
      warnings: normalizedWarnings,
    };

    this.setState({
      importFeedback,
      importToast: this.buildImportToast(importFeedback),
    });
  }

  private buildImportToast(feedback: PricingImportFeedback): ImportToast {
    const { updatedEntries, errors, warnings } = feedback;
    const summaryText =
      updatedEntries > 0
        ? `Applied ${updatedEntries} accessory price${
            updatedEntries === 1 ? "" : "s"
          }. Please check and press "Update prices" to finalize the update.`
        : "No accessory prices were updated.";

    if (errors.length > 0) {
      return {
        type: "error",
        header: "Import failed",
        body: (
          <div>
            {errors.map((error, index) => (
              <div key={`import-error-${index}`}>{error}</div>
            ))}
          </div>
        ),
      };
    }

    if (warnings.length > 0) {
      return {
        type: "warning",
        header: "Partial import",
        body: (
          <div>
            <div>{summaryText}</div>
            <ul>
              {warnings.map((warning, index) => (
                <li key={`import-warning-${index}`}>{warning}</li>
              ))}
            </ul>
          </div>
        ),
      };
    }

    return {
      type: "success",
      header: "Upload successfully processed",
      body: <div>{summaryText}</div>,
    };
  }

  private getValueKey(item: any) {
    return `${item.groupKey || ""}__${item.key || ""}`;
  }

  private buildBaselineMap(items: any[]) {
    const map: Record<string, string> = {};
    (items || []).forEach((item) => {
      map[this.getValueKey(item)] = item.value || "";
    });
    return map;
  }

  private hasPriceChanged(item: any) {
    const baselineValue = this.state.baselineValues[this.getValueKey(item)];
    if (baselineValue === undefined) {
      return false;
    }

    return baselineValue !== item.value;
  }

  private getPreviousPrice(item: any) {
    return this.state.baselineValues[this.getValueKey(item)];
  }

  private get pricingId(): string | undefined {
    const { match } = this.props;

    return match && match.params && match.params.pricingId;
  }
}

export const PricingsAccessories = connect((state: GlobalPrivateState) => ({
  pricing: state.pricing,
  pricings: state.pricings,
  params: state.queryState.params,
}))(PricingsAccessoriesPartial);

export default PricingsAccessories;
